import { Guid } from '@web/utils';

export class AdminOrderItemComponentAttribute {
  public constructor(
    private readonly data: {
      id: Guid;
      label: string;
      value: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get label(): string {
    return this.data.label;
  }

  public get value(): string {
    return this.data.value;
  }
}
